import { API_BASE_URL, API_PATHS, } from "../utils/constants/api.constants";
import axiosInstance from "../utils/authUtils";


class ProfileService {

    static getProfile(item) {

        let api = `${API_BASE_URL}${API_PATHS.getProfile}`;

        const params = new URLSearchParams();

        if ([...params].length > 0) {
            api += `?${params.toString()}`;
        }

        return axiosInstance.get(api, item);
    }

    static getDashboardSummary(item) {

        let api = `${API_BASE_URL}${API_PATHS.getDashboardSummary}`;

        return axiosInstance.get(api, item);
    }



    static getMyTeamList(item) {

        let api = `${API_BASE_URL}${API_PATHS.getMyTeamList}`;

        return axiosInstance.get(api, item);
    }



    static getDirectReferrals(item) {
        const api = `${API_BASE_URL}${API_PATHS.getDirectReferrals}`;

        return axiosInstance.get(api, {
            params: item,
        });
    }

    static getQr(item) {

        let api = `${API_BASE_URL}${API_PATHS.getQr}`;

        return axiosInstance.get(api, item);
    }

    static getMyReferralLevels(item) {

        let api = `${API_BASE_URL}${API_PATHS.getMyReferralLevels}`;

        return axiosInstance.get(api, item);
    }


    static editProfile(data) {

        let api = '';
        api = `${API_BASE_URL}${API_PATHS.editProfile}`;
        return axiosInstance
            .put(api, data)

    }
    static changePassword(data) {

        let api = '';
        api = `${API_BASE_URL}${API_PATHS.changePassword}`;
        return axiosInstance
            .put(api, data)

    }

    static submitJoiningPayment(data) {

        let api = '';
        api = `${API_BASE_URL}${API_PATHS.submitJoiningPayment}`;
        return axiosInstance
            .post(api, data)

    }

    static editFamilyDetails(data) {

        let api = '';
        api = `${API_BASE_URL}${API_PATHS.updateFamilyDetails}`;
        return axiosInstance
            .put(api, data)

    }


    static editProfessionalDetails(data) {

        let api = '';
        api = `${API_BASE_URL}${API_PATHS.updateProfessionalDetails}`;
        return axiosInstance
            .put(api, data)

    }


    static deleteProfile(id) {
        let api = '';

        api = `${API_BASE_URL}${API_PATHS.deleteProfile}?id=${id}`;

        return axiosInstance
            .delete(api)
    }


}

export default ProfileService;
